module.exports = __webpack_public_path__ + "img/favourite.b819a48f.png";